import { Component, Prop } from 'vue-property-decorator';
import { BaseComponent } from '../base-component';
import { ApartmentSearchDTO } from '@/model/ApartmentSearchDTO';
import { ApartmentPriceTableColumn } from '@/enums/ApartmentPriceTableColumn';
import ApartmentPriceCard from '../apartment-price-card/apartment-price-card';
import { CGReservationStatus } from '@/enums/CGReservationStatus';
import { ApartmentFeature } from '@/enums/ApartmentFeature';

@Component({
	components: {
		ApartmentPriceCard
	}
})
export class ApartmentPriceCards extends BaseComponent {
	@Prop() items: ApartmentSearchDTO[];
	@Prop() hideColumns: ApartmentPriceTableColumn[];

	get allHideColumns() {
		return [
			...(this.hideColumns || []),
			...(!this.showSpecialEquipment
				? [ApartmentPriceTableColumn.SpecialEquipment]
				: []),
			...(this.isPreview ? [ApartmentPriceTableColumn.Favorite] : []),
			...(!this.showBonus ? [ApartmentPriceTableColumn.Bonus] : [])
		];
	}

	get showPackagePrice() {
		return this.items.some(
			i =>
				i.packagePriceWithVAT > 0 &&
				i.cgReservationStatus !== CGReservationStatus.ShowApartment &&
				!i.features.includes(ApartmentFeature.PremiumPriceOnRequest)
		);
	}

	get showPackageInfo() {
		return this.items.some(
			i =>
				i.packageInfo !== null &&
				i.packageInfo.length > 0 &&
				i.cgReservationStatus !== CGReservationStatus.ShowApartment &&
				!i.features.includes(ApartmentFeature.PremiumPriceOnRequest)
		);
	}

	get showFinalDiscount() {
		return this.items.some(
			i =>
				i.finalDiscount > 0 &&
				i.cgReservationStatus !== CGReservationStatus.ShowApartment &&
				!i.features.includes(ApartmentFeature.PremiumPriceOnRequest)
		);
	}

	get showSpecialEquipment() {
		return this.items.some(
			i =>
				i.hasAirCondition ||
				i.hasBuiltinWardrobe ||
				i.hasHeatRecovery ||
				i.hasHeatRecoveryWithoutCooling ||
				i.hasJacuzzi ||
				i.hasKitchenCabinet ||
				i.hasRollerBlinds ||
				i.hasRollerBlindsPreparation ||
				i.hasRollerBlindsInPart ||
				i.hasRollerBlindsPreparationInPart ||
				i.hasRollerShutter ||
				i.hasRollerShutterPreparation ||
				i.hasRollerShutterInPart ||
				i.hasRollerShutterPreparationInPart
		);
	}

	get showBonus() {
		return this.items.some(i => !!i.tooltip);
	}

	get isPreview() {
		return this.$route.query.predbezne && this.$route.query.csh;
	}

	showColumn(column: ApartmentPriceTableColumn) {
		return !this.allHideColumns || !this.allHideColumns.includes(column);
	}
}

export default ApartmentPriceCards;
